export default __webpack_public_path__ + "images/8d78f09dcb8e9fabc5b69834b4cb551f-philadelphia_mobile.webp";